var _defs, _path, _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSpeciality(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 29.946,
    height: 29.947,
    viewBox: "0 0 29.946 29.947",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.a,.b,.c{fill-rule:evenodd;}.b{fill:#4b4495;stroke:#4b4495;}.c{fill:#48d1cc;stroke:#48d1cc;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M16.127,16.161l-4.7,4.7h0a7.425,7.425,0,1,0,10.5,10.5l4.7-4.7.018-.018h0l.016-.017,4.7-4.7a7.424,7.424,0,1,0-10.5-10.5l-4.7,4.7-.018.016h0a.121.121,0,0,0-.016.019ZM26.214,30.872a6.566,6.566,0,0,1,8.07-4.66h0a6.592,6.592,0,1,1-3.411,12.736h0a6.568,6.568,0,0,1-4.659-8.076",
    transform: "translate(-9.228 -9.227)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(5.168 2.808)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M17.779,22.763l-4.062,4.062h0a5.61,5.61,0,0,0-1.642,3.962,5.529,5.529,0,0,0,5.536,5.537,5.61,5.61,0,0,0,3.962-1.643h0l4.062-4.062Z",
    transform: "translate(-10.203 -13.864)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M22.764,17.778l4.061-4.061h0a5.61,5.61,0,0,1,3.962-1.643,5.527,5.527,0,0,1,5.536,5.535,5.613,5.613,0,0,1-1.642,3.963h0l-4.062,4.062Z",
    transform: "translate(-13.864 -10.203)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-16.31 -11.192)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M40.179,46.508l2.4-8.94c-.1-.009-.2-.011-.3-.011a4.723,4.723,0,0,0-4.557,3.5h0a4.72,4.72,0,0,0,2.456,5.449Z",
    transform: "translate(-18.932 -18.93)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M35.657,32.986l-2.4,8.941c.1.007.2.011.3.011a4.723,4.723,0,0,0,2.1-8.952Z",
    transform: "translate(-10.203 -13.864)"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeciality);
export default __webpack_public_path__ + "static/media/speciality.fbae103606e3f1e9535e82f68786fdfb.svg";
export { ForwardRef as ReactComponent };